import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import Layout from 'Layout/Layout';
import Header from 'Layout/Header';
import { withLocale } from '@dietlabs/components';
import PropTypes from 'prop-types';
import ProgressPlaceholder from './Progress/HydrationDayProgressPreloader';
import GoalPlaceholder from './Goal/HydrationDayGoalPlaceholder';
import GoalHeaderPlaceholder from './Goal/HydrationDayGoalHeaderPlaceholder';
import AddPlaceholder from './Add/HydrationAddPlaceholder';

class HydrationDayContainerPlaceholder extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
    };

    render() {
        return (
            <Layout page="hydration">
                <Header>{this.props.t('route-title/hydration-day')}</Header>
                <Container>
                    <Row>
                        <Col
                            xs={12}
                            md={{ size: 8, offset: 2 }}
                            lg={{ size: 6, offset: 3 }}
                        >
                            <GoalHeaderPlaceholder />
                            <ProgressPlaceholder />
                            <GoalPlaceholder />
                            <AddPlaceholder />
                        </Col>
                    </Row>
                </Container>
            </Layout>
        );
    }
}

export default withLocale(HydrationDayContainerPlaceholder);
